export default "__VITE_ASSET__DU_Dw37D__"